import React from 'react'
import styled from "@emotion/styled";
import {css} from "@emotion/core";

const CaretRightIconWrapper = styled(`div`)(css`
  display: inline;
  margin-left: 6px;
`);

export const CaretRightIcon = () => {
  return (
    <CaretRightIconWrapper>
      <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.999675 11.6667L6.33301 6.33333L0.999675 1" stroke="white" stroke-width="2"/>
      </svg>
    </CaretRightIconWrapper>
  )
}
